const breakPoints = {
  mobileWidth: 768,
  tabletWidth: 992,
  desktopWidth: 1200,
};

const constants = { breakPoints };

export default constants;
